export interface SubscriptionProvider {
  appName: string;
  portalPath: string;
}

export const SUBSCRIPTION_PROVIDERS: Record<string, SubscriptionProvider> = {
  APPSTLE: {
    appName: 'appstle',
    portalPath: '/apps/subscriptions',
  },
  RECHARGE: {
    appName: '294517',
    portalPath: '/tools/recurring/login',
  },
};

export const SUBSCRIPTION_PROVIDER_KEYS = Object.keys(SUBSCRIPTION_PROVIDERS);
